var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#EBE0D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8527 17.2825C26.9027 17.0149 27.0447 16.7732 27.2542 16.5992C27.4636 16.4253 27.7273 16.3301 27.9995 16.3301C28.2718 16.3301 28.5355 16.4253 28.7449 16.5992C28.9544 16.7732 29.0964 17.0149 29.1464 17.2825L30.3725 23.7669C30.4596 24.2279 30.6837 24.6519 31.0154 24.9837C31.3472 25.3154 31.7712 25.5395 32.2322 25.6265L38.7165 26.8527C38.9842 26.9027 39.2259 27.0447 39.3998 27.2542C39.5738 27.4636 39.669 27.7273 39.669 27.9995C39.669 28.2718 39.5738 28.5355 39.3998 28.7449C39.2259 28.9544 38.9842 29.0964 38.7165 29.1464L32.2322 30.3725C31.7712 30.4596 31.3472 30.6837 31.0154 31.0154C30.6837 31.3472 30.4596 31.7712 30.3725 32.2322L29.1464 38.7165C29.0964 38.9842 28.9544 39.2259 28.7449 39.3998C28.5355 39.5738 28.2718 39.669 27.9995 39.669C27.7273 39.669 27.4636 39.5738 27.2542 39.3998C27.0447 39.2259 26.9027 38.9842 26.8527 38.7165L25.6265 32.2322C25.5395 31.7712 25.3154 31.3472 24.9837 31.0154C24.6519 30.6837 24.2279 30.4596 23.7669 30.3725L17.2825 29.1464C17.0149 29.0964 16.7732 28.9544 16.5992 28.7449C16.4253 28.5355 16.3301 28.2718 16.3301 27.9995C16.3301 27.7273 16.4253 27.4636 16.5992 27.2542C16.7732 27.0447 17.0149 26.9027 17.2825 26.8527L23.7669 25.6265C24.2279 25.5395 24.6519 25.3154 24.9837 24.9837C25.3154 24.6519 25.5395 24.2279 25.6265 23.7669L26.8527 17.2825Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.333 16.334V21.0007",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 18.666H35",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 39.6667C19.955 39.6667 20.9997 38.622 20.9997 37.3333C20.9997 36.0447 19.955 35 18.6663 35C17.3777 35 16.333 36.0447 16.333 37.3333C16.333 38.622 17.3777 39.6667 18.6663 39.6667Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesOne);
export default __webpack_public_path__ + "static/media/features-one.876b5e0e546ff2f1f50e35e3db4caedd.svg";
export { ForwardRef as ReactComponent };